import React from "react";
import classNames from "classnames";
import {SectionSplitProps} from "../../utils/SectionProps";
import SectionHeader from "./partials/SectionHeader";
import Image from "../elements/Image";
import {withTranslation} from "react-i18next";

const propTypes = {
  ...SectionSplitProps.types
};

const defaultProps = {
  ...SectionSplitProps.defaults
};

const Section4 = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  invertMobile,
  invertDesktop,
  alignTop,
  imageFill,
  ...props
}) => {
  const outerClasses = classNames(
    "features-split section",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  const innerClasses = classNames(
    "features-split-inner section-inner",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider"
  );

  const splitClasses = classNames(
    "split-wrap",
    invertMobile && "invert-mobile",
    invertDesktop && "invert-desktop",
    alignTop && "align-top"
  );

  const sectionHeader = {
    title: "The world of influence will no longer hold any secrets for you.",
    paragraph: ""
  };

  const content = {
    title : "",
    paragraph : "",
    div1 : {
      subtitle : "A global vision",
      text : "Every day, you will see on your dashboard the best influencers and stores of the moment. No more 'tendencies' will escape you.",
      comment : "We have been using Ecomspy for less than 3 days and we are already 200% more profitable.",
      name : "Yomi Denzel",
      avatarImg : "denzel.jpg"
    },
    div2 : {
      subtitle : "A complete analysis",
      title : "Select your ideal influencer",
      text : "Finding the right influencer is always complicated, but that was before. With Ecomspy, you'll get much better insights! The percentage of real subscribers, the number of placements per day and many other factors to take into account. the country of subscribers, the retention rate."
    }
  }
  const {t, id} = props;
  return (
    <section id={id} className={outerClasses}>
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <div className={splitClasses}>
            <div className="split-item">
              <div
                className="split-item-content center-content-mobile reveal-from-left"
                data-reveal-container=".split-item"
              >
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  {t(content.div1.subtitle)}
                </div>
                <p className="mt-0 mb-12">
                  {t(content.div1.text)}
                </p>
                <img
                  src={require("./../../assets/images/"+content.div1.avatarImg)}
                  alt="avatar_quote"
                  style={{borderRadius: "50%", width: "100px", margin: "auto"}}
                />
                <div className="testimonial-item-content">
                  <p className="text-sm mb-0" style={{textAlign: "center"}}>
                    -{" "}
                    {t(content.div1.comment)}
                  </p>
                </div>
                <div
                  className="testimonial-item-footer text-xs mt-32 mb-0 has-top-divider"
                  style={{textAlign: "center"}}
                >
                  <span className="testimonial-item-name text-color-high">
                    {content.div1.name}
                  </span>
                  <span className="text-color-low"> / </span>
                  <span className="testimonial-item-link">
                    
                  </span>
                </div>
              </div>
              <div
                className={classNames(
                  "split-item-image center-content-mobile reveal-from-bottom",
                  imageFill && "split-item-image-fill"
                )}
                data-reveal-container=".split-item"
              >
                <Image
                  src={require("./../../assets/images/saas.svg")}
                  alt="Features split 01"
                  width={528}
                  height={396}
                />
              </div>
            </div>

            <div className="split-item">
              <div
                className="split-item-content center-content-mobile reveal-from-right"
                data-reveal-container=".split-item"
              >
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  {t(content.div2.subtitle)}
                </div>
                <h3 className="mt-0 mb-12">
                  {t(content.div2.title)}
                </h3>
                <p className="m-0">
                  {t(content.div2.text)}
                </p>
              </div>
              <div
                className={classNames(
                  "split-item-image center-content-mobile reveal-from-bottom",
                  imageFill && "split-item-image-fill"
                )}
                data-reveal-container=".split-item"
              >
                <Image
                  src={require("./../../assets/images/saas.svg")}
                  alt="Features split 02"
                  width={528}
                  height={396}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

Section4.propTypes = propTypes;
Section4.defaultProps = defaultProps;

export default withTranslation()(Section4);
